
import './globals/window'
import ioClient from 'socket.io-client'
import * as EM from '@multipple/extension-manager'
// JSON data
import Locales from 'json/languages'
import Countries from 'json/countries'
import Currencies from 'json/currencies'


function getInitialScope(){

  function resolveScope( initStr ){

    const
    b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
    [ str, salt ] = initStr.split('$')

    if( !str || !salt ) return false
    let result = '', i = 0

    // Remove the unknown striing portion
    initStr = str.replace( new RegExp( salt.split('').reverse().join(''), 'g' ), '')
                  .split('').reverse().join('')

    do {
      let
      b1 = b64.indexOf( initStr.charAt(i++) ),
      b2 = b64.indexOf( initStr.charAt(i++) ),
      b3 = b64.indexOf( initStr.charAt(i++) ),
      b4 = b64.indexOf( initStr.charAt(i++) ),

      a = ( ( b1 & 0x3F ) << 2 ) | ( ( b2 >> 4 ) & 0x3 ),
      b = ( ( b2 & 0xF  ) << 4 ) | ( ( b3 >> 2 ) & 0xF ),
      c = ( ( b3 & 0x3  ) << 6 ) | ( b4 & 0x3F )

      result += String.fromCharCode( a )+( b ? String.fromCharCode( b ) : '' )+( c ? String.fromCharCode( c ) : '' )
    }
    while( i < initStr.length )

    try { return JSON.parse( result ) }
    catch( error ){
      console.log('Failed Parsing Init Scope String: ', error )
      return false
    }
  }

  return new Promise( ( resolve, reject ) => {
      // Scope set at www. page rendereing
      let data = uiStore.get('init')
      if( data ) return resolve( resolveScope( data ) )

      // Explicitly fetch the scope
      fetch('/init')
          .then( res => { return !res.ok ? reject( res.status ) : res.json() } )
          .then( res => resolve( resolveScope( res ) ) )
  } )
}

function getWebsiteAssets(){
  return new Promise( ( resolve, reject ) => {
    fetch('/pages')
          .then( res => { 
            try { return !res.ok ? reject( res.status ) : res.json()  }
            catch( error ){ reject( error ) }
          } )
          .then( resolve )
  } )
}

function getDefaultPage( institution, manifest ){
  // Public site
  if( !manifest || !manifest.skeleton ) return 'signin'
  
  const accounttype = manifest.skeleton.type.toLowerCase()
  if( institution
      && institution.settings
      && institution.settings[ accounttype +'s']
      && institution.settings[ accounttype +'s'].defaultPage )
    return institution.settings[ accounttype +'s'].defaultPage

  return manifest.skeleton.defaultPage
}

function initRoutes( pages, theme ){
  // Page Routes
  return Object.entries( pages  )
                .map( ([ name, route ]) => {

                  // Path to the page component
                  const file = route.component // relative path specified
                                /* Derive component path from route name (Pages folder root)
                                  Convert underscore Case words to CamelCase words
                                */
                                || name.toCapitalCase()
                                        .replace( /_([a-z]{1})/g, ( matche, rp ) => {
                                          return rp.replace('_','').toUpperCase()
                                        } )
                  // Fetch page template
                  let component
                  try { component = require(`./views/${theme.name}/pages/${file}`) }
                  catch( error ){ component = require(`./views/${theme.name}/pages/${file}/index`) }

                  return { name, component, path: route.path }
                } )
}

function initScreenSet( e ){
  const
  $window =  $( e && e.target ? this : document ),
  width = $window.width(),
  height = $window.height()

  let media = 'xs'

  if( width >= 576 ) media = 'sm'
  if( width >= 768 ) media = 'md'
  if( width >= 992 ) media = 'lg'
  if( width >= 1200 ) media = 'xl'
  
  GState.set( 'screen', { media, width, height } )
}

function initNotification( request, user ){

  GState.set( 'notifications', window.uiStore.get('notifications') || {} )
  GState
  .define('notification')
  .action( 'new', ( id, payload ) => {
    const notifs = GState.get('notifications')
    
    if( !notifs[ id ] ) notifs[ id ] = []
    notifs[ id ].push( payload )

    GState.dirty( 'notifications', notifs )
    window.uiStore.set( 'notifications', notifs )
  } )
  .action( 'clear', id => {
    const notifs = GState.get('notifications')
    
    delete notifs[ id ]
    GState.dirty( 'notifications', notifs )
    window.uiStore.set( 'notifications', notifs )
  } )

  return
  
  if( !user.settings.notification.push )
    return // This user disable push notification

  // ioClient( request.pushServer, {
  //                                 transportOptions: {
  //                                   polling: {
  //                                     extraHeaders: {
  //                                       'MP-User-Agent': request.headers['MP-User-Agent'],
  //                                       'MP-Auth-Device': request.headers['MP-Auth-Device'],
  //                                       'MP-Auth-Token': user.settings.notification.push
  //                                     }
  //                                   }
  //                                 }
  //                               } )
  // .on( 'connect', () => console.log('Connected to ANM') )
  // .on( 'NOTIFICATION::NEW', body => {

  //   const
  //   title = 'New Notification',
  //   payload = {
  //               badge: 'images/favicon/newave-800x800.png',
  //               icon: 'images/icon/printer.png',
  //               // image: 'http://localhost:2020/images/icon/printer.png',
  //               body: 'You\'ve won the Today\'s Miday Session of LoTToCash: PowerMan hit !!!',
  //               lang: 'FR',
  //               tag: '12diDoLSO',
  //               vibrate: [ 200, 100, 200, 100, 200, 100, 400 ],
  //               // silent: false,
  //               // actions: [
  //               //   { action: 'yes', title: 'Yes', icon: 'images/yes.png' },
  //               //   { action: 'no', title: 'No', icon: 'images/no.png' }
  //               // ],
  //               data: {
  //                   url: 'https://localhost:2020/app/lottocash#ongoing?action=history&playcode=12diDoLSO',
  //                   user_id: 'user-phone-number',
  //                   user_name: ''
  //               },
  //               // renotify: false
  //             }

  //     // Let's check if the browser supports notifications
  //     if( !( 'Notification' in window ) ){
  //       console.log('[NOTIFICATION]: This browser does not support desktop notification')
  //       return
  //     }

  //     // Let's check whether notification permissions have already been granted
  //     if( Notification.permission === 'granted' ){
  //       // If it's okay let's create a notification
  //       const notif = new Notification( title, payload )

  //       return
  //     }

  //     // Otherwise, we need to ask the user for permission
  //     if( Notification.permission !== 'denied' )
  //       Notification.requestPermission()
  //                   .then( function( permission ){
  //                     // If the user accepts, let's create a notification
  //                     if( permission == 'granted' ){
  //                       const notif = new Notification( title, payload )

  //                     }
  //                   } )

  //     // At last, if the user has denied notifications, and you
  //     // want to be respectful there is no need to bother them any more.
  // } )
}

async function initLocale( locale ){
  
  const [ language, variant ] = locale.split('-')
  let dictionary = await AppRequest('/translation/'+ language )
  
  // Mount new translation dictionary
  GState.set('locale', { language, variant, dictionary })
}

async function initOfficialWebsite( Routes, theme ){
  try {
    // Fetch generated website pages 
    const { banner, pages } = await getWebsiteAssets()
    
    GState.set( 'website', pages )
    GState.set( 'banner', banner ) // Use as background for auth pages

    // Route handler of all possible site pages
    Routes.push({
      name: 'site-pages',
      path: `/:page`, 
      component: require(`./views/${theme.name}/pages/Website`)
    })

    return Routes
  }
  catch( error ){
    console.log('[Official Website] Initialization Error: ', error )
    return Routes
  }
}

async function updateUser( payload, target ){

  const user = GState.get('user')

  Object.entries( payload )
        .map( ([ key, value ]) => {

          if( /\./.test( key ) )
            try { eval( 'user.'+( target && target != 'profile' ? target +'.' : '' )+ key +' = value' ) }
            catch( error ){ console.log('Invalid User Key: ', error ) }

          else user[ key ] = value
        } )

  // Update user session & State (Target "personal" data by default)
  try {
    const updatedUser = await updateUserSession( payload, target )
    GState.set( 'user', updatedUser )
  }
  catch( error ){ console.log('User State & Session Update Failed: ', error ) }
}

async function updateUserSession( payload, target ){
  try {
    const { error, message, user } = await AppRequest( '/update-session/user', 'PUT', { payload, target } )

    if( error ) throw new Error( message )
    return user
  }
  catch( error ){ throw error }
}

async function refreshUser(){
  // Refresh user session
  const user = GState.get('user')
  try { GState.set( 'user', await updateUserSession({ first_name: user.first_name }, 'profile' ) ) }
  catch( error ){ console.log('Tenant State & Session refresh Failed: ', error ) }
}

async function updateTenant( payload, target ){

  const tenant = GState.get('tenant')

  Object.entries( payload )
        .map( ([ key, value ]) => {

          if( /\./.test( key ) )
            try { eval( 'tenant.'+( target ? target +'.' : '' )+ key +' = value' ) }
            catch( error ){ console.log('Invalid Tenant Key: ', error ) }

          else tenant[ key ] = value
        } )

  // Update tenant session & State (Target "settings" data by default)
  try {
    const updatedTenant = await updateTenantSession( payload, target )
    GState.set('tenant', updatedTenant )
  }
  catch( error ){ console.log('Tenant State & Session Update Failed: ', error ) }
}

async function refreshTenant(){
  // Refresh tenant session
  const tenant = GState.get('tenant')
  try { GState.set( 'tenant', await updateTenantSession({ name: tenant.name }) ) }
  catch( error ){ console.log('Tenant State & Session refresh Failed: ', error ) }
}

async function updateTenantSession( payload, target ){
  try {
    const { error, message, institution } = await AppRequest( '/update-session/institution', 'PUT', { payload, target } )

    if( error ) throw new Error( message )
    return institution
  }
  catch( error ){ throw error }
}

// App Initialization
;( async () => {
  try {
    const {
      env,
      version,
      defaults,
      tenant,
      isConnected,
      userData,
      institutionData,
      authData,
      manifest,
      request,
      vts,
      socket,
      ipstack,
      paystack
    } = await getInitialScope(),
          
    // Current connection's account type
    accountType = isConnected ? userData.accounttype : 'visitor',
    // Initial Theme
    Theme = ( tenant && tenant.settings.theme ) || defaults.theme
    
    if( authData !== undefined ){
      // Post authentication redirecting process
      GState.set( 'auth', authData )
    
    }
    
    if( isConnected ){
      GState.set('user', userData )
      GState.set('sections', manifest.sections )
      GState.set('skeleton', manifest.skeleton )
      
      // Enlarge tenant data with all allowed institution data
      institutionData !== undefined && Object.assign( tenant, institutionData )
      
      /*
      const notifications = [
        {
          type: 'success',
          origin: { name: 'Revel System' },
          subject: 'Delivery of your order is on 12/04/22',
          content: "We'll send you frequent email to let you know the shipping state or your order. Your delivery location is Ghana-Accra, Legon state. Let us know if any change of location is imposed. Thank you",
          datetime: 1214567899094
        },
        {
          // type: 'primary',
          origin: { name: 'LG Digital Pro', link: '/shop?id=123' },
          subject: 'New Arrival Products',
          content: "Breaking market products arrival in july 17. Make your order now to get a first order discount of 20%.",
          posters: [
            { src: '/images/elements/bestselling06-product.jpg', width: '80px', height: '80px' },
            { src: '/images/elements/bestselling07-product.jpg', width: '80px', height: '80px' }
          ],
          datetime: 1214567899094
        },
        {
          type: 'success',
          origin: {
            system: true,
            name: 'VendOne - Service'
          },
          subject: 'Subscription Renewed',
          content: "Your new subscription is successfully done and automatically applied to all the services it covers. Thank you for using our services. For more help, contact our support team.",
          datetime: 1214567899094
        },
        {
          type: 'warning',
          origin: {
            system: true,
            name: 'VendOne - Security Guard',
            link: '/confirm/security'
          },
          subject: 'Intrusion Alert',
          content: "An attempt to access your account from a 3rd party platform is detected. Kindly confirm if it's you for security purpose",
          datetime: 1214567899094
        },
        {
          type: 'info',
          origin: {
            system: true,
            name: 'VendOne Service',
            link: '/subscription'
          },
          subject: 'Subscription Status',
          content: "Your subscription is about to expirer. Renew now to enjoy our early subscription renewal discount",
          datetime: 1214567899094
        },
        {
          type: 'danger',
          origin: {
            system: true,
            name: 'VendOne - Security Service',
            link: '/policy/quiz'
          },
          subject: 'Security Bridge Detected',
          content: "We're recorded some unusual suspicious activities recently from your account. Click on this notification to assess our policy checking quizzes or your account could be suspended.",
          datetime: 1214567899094
        },
      ]
      */
      const notifications = []

      GState.set('user', userData )
      GState.set('paystackDefaultCreds', paystack )
      GState.set('notification', notifications )
      GState.set('vts', vts )

      GState
      .define('user')
      .action('update', updateUser )
      .action('refresh', refreshUser )

      GState
      .define('tenant')
      .action('update', updateTenant )
      .action('refresh', refreshTenant )

      GState
      .define('notification')
      .action('update', () => {
        console.log('Update Notifications')
      } )
      
      GState.set('marketplace', uiStore.get('active-marketplace') )
      GState
      .define('marketplace')
      .action('open', payload => {
        GState.set('marketplace', payload || true )
        uiStore.set('active-marketplace', payload || true )
        
        // Open aside when no active extension
        !Object.keys( GState.get('activeExtensions') ).length
        && GState.workspace.layout({ mode: ['xs', 'sm'].includes( GState.get('screen').media ) ? 'qs' : 'hs' })
      } )
      .action('close', () => {
        GState.set('marketplace', false )
        uiStore.clear('active-marketplace')
        
        // Close aside when no active extension
        !Object.keys( GState.get('activeExtensions') ).length
        && GState.workspace.layout({ mode: 'ns' })
      } )

      GState
      .define('global')
      .action('alert', payload => GState.set('alert', payload ) )
    }
    else GState.set('public', manifest.public )
    
    /*----------------------------------------------------------------*/
    // Initial States
    GState.set('theme', Theme )
    GState.set('locales', Locales )
    GState.set('countries', Countries )
    GState.set('currencies', Currencies )
    GState.set('ipstack', ipstack )
    
    /*----------------------------------------------------------------*/
    // On tenant domain site
    tenant !== undefined && GState.set('tenant', tenant )

    /*----------------------------------------------------------------*/
    /* Initial Workspace State: 
      - Context: Use for extensions & user activities tracking by page
                  @params: 
                    - accountType(Admin, Instructor, Learner)
                    - page( route name )
                    - event( name, ID )
      - Layout: Display or main blocks of the workspace
            @params:
              - mode: UI segmentation mode
                  - qs (Quater state)
                  - hs (Half section)
                  - ns (No-section)
    */
    const wsStoreAttr = 'workspace-'+ accountType
    
    GState.set('workspace', { mode: 'ns', ...(uiStore.get( wsStoreAttr ) || {}) })
    GState
    .define('workspace')
    // Update workspace Layout
    .action('layout', newState => {
      const recentState = GState.get('workspace')
      if( newState.mode == 'ns' && recentState.mode !== 'ns' )
        newState.previousMode = recentState.mode

      else if( newState.mode == 'auto' )
        newState.mode = recentState.previousMode || 'qs'
      
      newState = Object.assign( {}, recentState, newState )

      GState.dirty( 'workspace', newState )
      uiStore.set( wsStoreAttr, newState )
    } )
    // Set/Define workspace context
    .action('context', newState => {

      const wsState = GState.get('workspace')
      wsState.context = Object.assign( wsState.context || {}, newState, { accountType } )

      GState.dirty( 'workspace', wsState )
    } )

    /*----------------------------------------------------------------*/
    /* Initialize activity track handler

      The use of this feature is to get back to left-off
      incompleted process at a single click on the footer bar.

      For instance, when user is filling a form and contrained
      to do something else on other pages without finish
      filling the form, the link to the form will show at the
      bottom footer of every other pages he goes to so he can
      get back to the form directly by clicking that link.
    */
    GState.set('activities', uiStore.get('activities') || [] )
    GState
    .define('activity')
    .action('add', payload => {
      // Get on track
      const activities = GState.get('activities')
      for( let o = 0; o < activities.length; o++ )
        if( activities[ o ].title == payload.title )
          return // already registered

      // Newly registered
      activities.push( payload )
      GState.set( 'activities', activities )
      uiStore.set( 'activities', activities )
    } )
    .action('remove', title => {
      // Get off track
      let activities = GState.get('activities')
      if( !activities.length ) return

      activities = activities.filter( each => { return each.title !== title } )
      GState.set( 'activities', activities )
      uiStore.set( 'activities', activities )
    } )

    /*----------------------------------------------------------------*/
    // Initial media window sizes
    initScreenSet()
    // Watch screen resize for responsiveness updates
    $(window).on( 'resize', initScreenSet )

    /*----------------------------------------------------------------*/
    // Language Switcher
    GState
    .define('locale')
    .action('switch', async locale => {
      await initLocale( locale )
      await updateUser({ 'language': locale }, 'settings' )
    } )

    // Initialize Dictionary Collection Record (DCR)
    GState.set('DCR', [])
    GState
    .define('DCR')
    .action('collect', text => {
      const collection = GState.get('DCR')

      if( collection.includes( text ) ) return
      collection.push( text )

      GState.dirty('DCR', collection )
    } )
    .action('clear', () => GState.set('DCR', [] ) )

    /*----------------------------------------------------------------*/
    // Learner/Instructor account Menu
    GState.set('showMenu', !['xs', 'sm', 'md'].includes( GState.get('screen').media ) )
    GState
    .define('menu')
    .action('show', status => GState.set('showMenu', status !== undefined ? status : !GState.get('showMenu') ) )

    /*----------------------------------------------------------------*/
    // Running Environment: To control logs and some UI components behavior
    window.env = env
    // Current Web Application version
    window.appversion = version
    // Application's default domain: web.multipple.com
    window.Defaults = defaults
    // Web Application Dedicated User-Agent
    window.UserAgent = request.headers['MP-User-Agent']
    // Assigned device ID
    window.Device.deviceId = request.headers['MP-Auth-Device']
    // Allow UI Translation Stack
    window.ALLOW_TRANSLATION_TRACK = tenant && tenant.settings.translate || false

    /*--------------------------------------------------------------------------*/
    // API request method
    window.Request = ( api, method, data ) => {
      return new Promise( ( resolve, reject ) => {

        if( window.OnbehalfOrigin )
          request.headers['MP-On-Behalf'] = window.OnbehalfOrigin
        
        const options = {
          method: method || 'GET',
          headers: {
            ...request.headers,
            'Content-Type': 'application/json'
          }
        }
        
        if( data ) options.body = JSON.stringify( data )
        
        fetch( request.apiServer + api, options )
            .then( res => { return !res.ok ? reject( res.status ) : res.json() } )
            .then( resolve )
            .catch( reject )
      } )
    }
    // Auth request handler
    window.AuthRequest = ( api, method, data ) => {
      return new Promise( ( resolve, reject ) => {
        
        const options = {
          method: method || 'GET',
          headers: {
            ...request.headers,
            'Content-Type': 'application/json'
          }
        }
        
        if( data ) options.body = JSON.stringify( data )
        
        fetch( request.authServer + api, options )
            .then( res => {
              try { return res.json() }
              catch( error ){ reject( res.statusText || res.status ) }
            } )
            .then( resolve )
            .catch( reject )
      } )
    }
    // Marketplace request method
    window.marketplace = request.mpsServer
    window.MPSRequest = ( api, method, data ) => {
      return new Promise( ( resolve, reject ) => {

        const options = {
          method: method || 'GET',
          headers: {
            ...request.headers,
            'Content-Type': 'application/json'
          }
        }
        
        if( data ) options.body = JSON.stringify( data )
        
        fetch( request.mpsServer +'/v1'+ api, options )
            .then( res => { return !res.ok ? reject( res.status ) : res.json() } )
            .then( resolve )
            .catch( reject )
      } )
    }
    // VTS micro-service Request handler
    window.VTSRequest = ( api, method, data ) => {
      return new Promise( ( resolve, reject ) => {
        
        const options = {
          method: method || 'GET',
          headers: {
            ...vts.headers,
            'Content-Type': 'application/json'
          }
        }
        console.log( options )
        
        if( data ) options.body = JSON.stringify( data )
        
        fetch( vts.server + api, options )
            .then( res => { return !res.ok ? reject( res.status ) : res.json() } )
            .then( resolve )
            .catch( reject )
      } )
    }
    // Browser to UI App request handler
    window.AppRequest = ( api, method, data ) => {
      return new Promise( ( resolve, reject ) => {
        
        const options = {
          method: method || 'GET',
          headers: { 'Content-Type': 'application/json' }
        }
        
        if( data ) options.body = JSON.stringify( data )
        
        fetch( api, options )
            .then( res => { return !res.ok ? reject( res.status ) : res.json() } )
            .then( resolve )
            .catch( reject )
      } )
    }
    // Get client's location details
    window.getClientLocation = force => {
      /* Lookup data behind this client's IP address
        @params force {Boolean} Execute lookup regardless previous saved data
      */
      return new Promise( ( resolve, reject ) => {

        if( !force ){
          // Return previous lookup data if there is
          const location = uiStore.get('user-location')
          if( location ) return resolve( location )
        }

        // To a new lookup
        fetch(`${ipstack.uri}/check?access_key=${ipstack.accessKey}&output=json`)
              .then( res => { return !res.ok ? reject( res.status ) : res.json() } )
              .then( res => {
                uiStore.set( 'user-location', res )
                resolve( res )
              } )
      } )
    }
    /* Locale text translation method from
      JS script. Helps when the need of transation
      is out of a component
    */
    window.Locale = ( text, notrack ) => {
      /* Static translation
        {
          ...
          "User account": "Compte utilisateur",
          ...
        }
      */
      const { language, variant, dictionary } = GState.get('locale')
      let translation = dictionary[ text ] || text
      
      /* Select defined variance
        {
          ...
          "Buy now": {
              "US": "Buy now",
              "UK": "Purchase now",
              "default": "US"
          }
          ...
        }
      */
      if( typeof translation == 'object' ){
        // Specified variant defined
        if( variant && translation.hasOwnProperty( variant ) )
          translation = translation[ variant ]

        // User first variant as default or default defined variant
        else {
          const defaultVariant = translation.default || Object.keys( translation )[0]
          translation = ( defaultVariant && translation[ defaultVariant ] ) || text
        }
      }

      if( ALLOW_TRANSLATION_TRACK && !notrack && text )
        GState.DCR.collect( text )

      return translation
    }

    /*----------------------------------------------------------------*/
    // Global UI Socket connection
    const configs = {
      transportOptions: {
        polling: { extraHeaders: { 'MP-User-Agent': window.UserAgent } }
      }
    }
    window.UISocket = ioClient.connect( '/'+ socket.namespace, configs )
                              .on( 'connect', () => console.log('[APP-CONNECT] Socket Connection Established') )
   
    /*----------------------------------------------------------------*/
    // Init locale language handlers
    try { await initLocale( ( userData && userData.language ) || navigator.language ) }
    catch( error ){
      console.log('[CLIENT-LOAD]- Failed to init Locale language: ', error )
      // Fetch en-US dictionary by default
      await initLocale('en-US')
    }
    
    /*----------------------------------------------------------------*/
    // Initial Notification handler
    initNotification( request, userData )

    /*----------------------------------------------------------------*/
    // Load installed Extensions
    if( tenant && isConnected ) await EM.load( accountType )

    /*----------------------------------------------------------------*/
    // Initial Routes: Mixte public and account type routes
    let Routes = initRoutes( Object.assign( {}, !isConnected ? manifest.public : {}, !!manifest.skeleton ? manifest.skeleton.pages : {} ), Theme )

    // Init generated official website
    Routes = await initOfficialWebsite( Routes, Theme )

    /*----------------------------------------------------------------*/
    // Default route page
    const DefaultPage = getDefaultPage( institutionData || tenant, manifest )
    // Render UI
    ;( await import(`./views/${Theme.name}/App.marko`) )
                  .renderSync({ Routes, DefaultPage })
                  .prependTo( document.body )
  }
  catch( error ){ console.error('[CLIENT-LOAD] - UI Initialization Failed: ', error ) }
} )()